export enum EmbedPartner {
  PROVET = 'provet'
}